var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon33417(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n      .cls-1,\n      .cls-2,\n      .cls-3 {\n        stroke-width: 0px;\n      }\n      .cls-2 {\n        fill: #00adee;\n      }\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.82,
    y: 78.13,
    width: 58.36,
    height: 9.59,
    rx: 4.79,
    ry: 4.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m68.85,12.31H31.15c-5.49-.44-13.98,6.3-14.14,14.14v25.79h65.98v-25.79c0-7.81-6.33-14.14-14.14-14.14Zm-29.97,34.14c0,.83-.6,1.5-1.34,1.5h-14.87c-.74,0-1.34-.67-1.34-1.5v-11.06c0-2.25,1.93-8.79,8.78-8.79s8.78,6.53,8.78,8.79v11.06Zm20.07-.15c0,.83-.6,1.5-1.34,1.5h-14.87c-.74,0-1.34-.67-1.34-1.5v-11.06c0-2.25,1.93-8.79,8.78-8.79s8.78,6.53,8.78,8.79v11.06Zm20.25,0c0,.83-.6,1.5-1.34,1.5h-14.87c-.74,0-1.34-.67-1.34-1.5v-11.06c0-2.25,1.93-8.79,8.78-8.79s8.78,6.53,8.78,8.79v11.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.86,56.33h-4.68c-3.13,0-5.66,2.54-5.66,5.66v7.8c0,3.13,2.54,5.66,5.66,5.66h4.68c3.13,0,5.66-2.54,5.66-5.66v-7.8c0-3.13-2.54-5.66-5.66-5.66Zm-2.34,12.52c-2.51,0-4.55-2.04-4.55-4.55s2.04-4.55,4.55-4.55,4.55,2.04,4.55,4.55-2.04,4.55-4.55,4.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.64,
    cy: 64.3,
    r: 4.71,
    transform: "translate(-36.2 41.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 68.85,
    cy: 64.15,
    r: 4.71,
    transform: "translate(-25.19 67.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17.01,53.66v10.48c0,7.07,5.18,12.92,11.94,13.98h42.09c6.77-1.05,11.94-6.91,11.94-13.98v-10.48H17.01Zm14.63,15.34c-2.61,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71Zm26.89.79c0,3.13-2.54,5.66-5.66,5.66h-4.68c-3.13,0-5.66-2.54-5.66-5.66v-7.8c0-3.13,2.54-5.66,5.66-5.66h4.68c3.13,0,5.66,2.54,5.66,5.66v7.8Zm10.33-.93c-2.61,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50.52,
    cy: 64.3,
    r: 4.55,
    transform: "translate(-13.42 13.33) rotate(-13.28)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon33417);
export default __webpack_public_path__ + "static/media/icon33417.8a5e036c9df793c128872848db8a1428.svg";
export { ForwardRef as ReactComponent };